export default __webpack_public_path__ + "static/media/phoenixlogo.1aa3fc01.jpg";